var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeeImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Fee_Purple"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fee_Purple",
    "data-name": "Fee Purple",
    clipPath: "url(#clip-Fee_Purple)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_01",
    "data-name": "Icon 01",
    transform: "translate(0.079 -0.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(-0.079 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 2.491)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1",
    "data-name": "Path 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5924",
    "data-name": "Path 5924",
    d: "M17.921,17.025h-18V6.482h18ZM.458,16.488H17.384V7.019H.458ZM8.924,15.7a3.952,3.952,0,1,1,3.952-3.952A3.956,3.956,0,0,1,8.924,15.7Zm0-7.367a3.415,3.415,0,1,0,3.415,3.415A3.419,3.419,0,0,0,8.924,8.338Z",
    transform: "translate(0.079 -6.482)",
    fill: "#6c5b7b",
    stroke: "#6c5b7b",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(7.747 4.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_2",
    "data-name": "Path 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5925",
    "data-name": "Path 5925",
    d: "M12.381,10.463a1.889,1.889,0,0,1,.363.064,1.677,1.677,0,0,1,.3.1l-.005.56a2.745,2.745,0,0,0-.425-.129A2.034,2.034,0,0,0,12.143,11a.819.819,0,0,0-.572.194.639.639,0,0,0-.215.494.844.844,0,0,0,.062.333.61.61,0,0,0,.17.235,2.715,2.715,0,0,0,.49.268l.358.167a1.433,1.433,0,0,1,.635.5,1.3,1.3,0,0,1,.18.7,1.1,1.1,0,0,1-.265.734,1.134,1.134,0,0,1-.605.371v.509H11.8V15.03a1.365,1.365,0,0,1-.651-.186v-.566a1.386,1.386,0,0,0,.37.17,1.487,1.487,0,0,0,.461.082.662.662,0,0,0,.487-.176.607.607,0,0,0,.177-.452.73.73,0,0,0-.064-.309.653.653,0,0,0-.182-.236,2.522,2.522,0,0,0-.461-.261l-.279-.13a1.669,1.669,0,0,1-.692-.542,1.433,1.433,0,0,1-.218-.821,1.02,1.02,0,0,1,.293-.723,1.207,1.207,0,0,1,.749-.381V9.984h.585Z",
    transform: "translate(-10.748 -9.984)",
    fill: "#6c5b7b",
    stroke: "#6c5b7b",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0.057 2.547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_3",
    "data-name": "Path 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5926",
    "data-name": "Path 5926",
    d: "M17.887,16.99H0V6.56H17.887ZM.424,16.566H17.463V6.982H.424Z",
    transform: "translate(0 -6.56)",
    fill: "#6c5b7b",
    stroke: "#6c5b7b",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(14.544 7.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_4",
    "data-name": "Path 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5927",
    "data-name": "Path 5927",
    d: "M20.647,14.436a.4.4,0,1,1,.4-.4h0A.4.4,0,0,1,20.647,14.436Zm0-.424a.026.026,0,0,0-.026.026h0c0,.028.051.029.052,0a.026.026,0,0,0-.026-.026Z",
    transform: "translate(-20.248 -13.639)",
    fill: "#6c5b7b",
    stroke: "#6c5b7b",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(2.66 7.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_5",
    "data-name": "Path 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5928",
    "data-name": "Path 5928",
    d: "M4.038,14.436a.4.4,0,1,1,.4-.4.4.4,0,0,1-.4.4Zm0-.424a.026.026,0,0,0-.026.026h0c0,.028.051.028.051,0a.026.026,0,0,0-.025-.026Z",
    transform: "translate(-3.639 -13.639)",
    fill: "#6c5b7b",
    stroke: "#6c5b7b",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(1.613 1.14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6",
    "data-name": "Path 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5929",
    "data-name": "Path 5929",
    d: "M16.95,6.213h-.424V5.018H2.6V6.213H2.176V4.594H16.951Z",
    transform: "translate(-2.176 -4.594)",
    fill: "#6c5b7b",
    stroke: "#6c5b7b",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(2.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_7",
    "data-name": "Path 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5930",
    "data-name": "Path 5930",
    d: "M16.227,4.352h-.421v-.93H4.278v.93H3.857V3H16.229Z",
    transform: "translate(-3.857 -3)",
    fill: "#6c5b7b",
    stroke: "#6c5b7b",
    strokeWidth: 0.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeeImage);
export default __webpack_public_path__ + "static/media/Fee_image.da0ae6db5e55b81371adb4b74862bae2.svg";
export { ForwardRef as ReactComponent };